import React, { useState, useEffect, useRef } from "react";
import AboutUs from "./AboutUs";
import VisionAndMission from "./VisionAndMission";
import WhyUs from "./WhyUs";

const TakeayaCompanySection = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [isVisible, setIsVisible] = useState(false);
  const tabsContainerRef = useRef(null);

  // Animate elements on mount
  useEffect(() => {
    setIsVisible(true);
  }, []);

  const tabs = [
    { id: "overview", label: "Company Overview" },
    { id: "vision", label: "Vision & Mission" },
    { id: "services", label: "Our Services" },
    { id: "why", label: "Why Choose Us" },
    { id: "technology", label: "Technology" },
  ];

  return (
    <>
      <AboutUs />
      <VisionAndMission />
      <WhyUs />
    </>
  );
};

export default TakeayaCompanySection;
